import { useEffect } from "react";
import { api } from "@/lib/api";

const loaded = {};
const cfgPromises = {};

export const loadRecaptcha = (key) => {
  loaded[key] ||= new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(key)}`;
    s.async = true;
    s.onload = () => window.grecaptcha.ready(resolve);
    s.onerror = () => { delete loaded[key]; reject(new Error("Could not load reCAPTCHA")); };
    document.head.appendChild(s);
  });
  return loaded[key];
};

export const executeRecaptcha = async (key, action) => {
  await loadRecaptcha(key);
  return window.grecaptcha.execute(key, { action });
};

const getConfig = (scope = "") => {
  cfgPromises[scope] ||= api.get(scope ? `/${scope}/recaptcha/config` : "/recaptcha/config").then((r) => r.data).catch(() => { delete cfgPromises[scope]; return { enabled: false }; });
  return cfgPromises[scope];
};

export const recaptchaToken = async (form, scope = "") => {
  const c = await getConfig(scope);
  if (!c.enabled || !c.forms?.[form]) return "";
  try { return await executeRecaptcha(c.site_key, form); } catch { return ""; }
};

export const useRecaptchaPreload = (form, scope = "") => {
  useEffect(() => {
    getConfig(scope).then((c) => { if (c.enabled && c.forms?.[form]) loadRecaptcha(c.site_key).catch(() => {}); });
  }, [form, scope]);
};
